import { render, staticRenderFns } from "./ApproachCard.vue?vue&type=template&id=6aaa247d"
import script from "./ApproachCard.vue?vue&type=script&lang=js"
export * from "./ApproachCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports